
import { defineComponent, onMounted, ref, computed } from 'vue'
import { useRoute } from 'vue-router';
import KTFile2 from "@/components/files/File2.vue";

import eventService from "@/core/services/EventService";
import { errManager } from "@/core/config/Tools";

export default defineComponent({
    name: "manager-sports",
    components: {
        KTFile2,
    },
    setup() {
        const route = useRoute();
        const { id } = route.params
        const loader = ref(false)
        const search = ref('')
        const listSports = ref<any>([])

        //lista de deportes por evento
        const getSports = async () => {
            loader.value = true
            await eventService.getSports({idevent:id})
            .then ( (res) => {
                listSports.value = res.data
                loader.value = false
            }).catch ( ({ response }) => {
                loader.value = false
                errManager(response)
            })
        }

        const filteredSports = computed(() => {
            return listSports.value.filter(
                (item) => item.name.toLowerCase().includes(search.value.toLowerCase())
            );
        });

        onMounted(()=>{
            getSports()
        })

        return {
            id,
            loader,
            search,
            listSports, 
            getSports,
            filteredSports
        }
        
    },
})
